var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.AppPage,{attrs:{"title":_vm.$t('transferredWages.pageTitle'),"subtitle":_vm.$t('transferredWages.pageSubtitle'),"icon":"exchange"},scopedSlots:_vm._u([{key:"custom-content",fn:function(){return [_c('b-col',[_c('b-card',[_c(_setup.StreamedWagesList)],1)],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }